import React from 'react';

export const PageTitle: React.FC<{ title: string }> = ({ title, children }) => (
    <div className="d-flex justify-content-between fullwidth page-title-holder">
        <div className="fs-20 mr-2 primary-color fw-500">{title}</div>
        <div className="col">{children}</div>
    </div>
);
